import { useHistory } from 'react-router-dom'

export function useNavigate(path: string, state?: {}, hash?: string) {
  const history = useHistory()
  return function navigate() {
    history.push({
      pathname: path,
      state,
      hash
    })
  }
}
